import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

export const appBorders = {
  backrsDropShadowBorders: {
    black: {
      border: `3px solid ${appColors.neutral.black}`,
      boxShadow: `5px 5px 0px 0px ${appColors.neutral.black}`,
    },
    blue: {
      border: `3px solid ${appColors.color.blue1}`,
      boxShadow: `5px 5px 0px 0px ${appColors.color.blue1}`,
    },
  },
  backrsBorders: {
    black: {
      border: `3px solid ${appColors.neutral.black}`,
    },
    blue: {
      border: `3px solid ${appColors.color.blue1}`,
    },
  },
} as const;
